import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=d32d8af4&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32d8af4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d32d8af4')) {
      api.createRecord('d32d8af4', component.options)
    } else {
      api.reload('d32d8af4', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=d32d8af4&scoped=true&", function () {
      api.rerender('d32d8af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HtzPjW1EL9Ne/JS/comp/SearchFilterTokens.vue"
export default component.exports